<template>
  <div/>
</template>

<script>
import { productInfo } from '@/mixins/productInfo'

export default {
  mixins: [productInfo],	
  name: "FooterBar"
}
</script>

<style>
ul a.nav-link {
	padding-top: 0;
}

ul li:first-child a.nav-link {
	padding-left: 0;
}
</style>